<template>
  <vx-card title="Subscriptions" no-shadow>
    <div slot="no-body" class="mt-4">
      <vs-table :data="subscriptions" class="table-dark-inverted">
        <template slot="thead">
          <vs-th>PRODUCT NAME</vs-th>
          <vs-th>PRODUCT PRICE</vs-th>
          <vs-th>STATUS</vs-th>
          <vs-th>EXPIRED AT</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].title">
              {{ data[indextr].product.title }}
            </vs-td>

            <vs-td :data="data[indextr].product.inAppPrice">
              {{ data[indextr].product.inAppPrice }}
              {{ data[indextr].product.currency }}
            </vs-td>

            <vs-td :data="data[indextr]">
              <vs-chip :color="data[indextr].isActive ? 'primary' : 'success'">
                {{ data[indextr].isActive ? 'Active' : 'deactivate' }}
              </vs-chip>
            </vs-td>

            <vs-td :data="data[indextr]">
              {{ data[indextr].validTo }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <Pagination :total="totalPage" v-model="currentPage" />
    </div>
  </vx-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Pagination from '@/components/Pagination';

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      itemsPerPage: 25,
      currentPage: 1,
      pageTotal: 0,
      totalItem: 0,
      totalPage: 0,
    };
  },
  computed: {
    ...mapState({
      user: ({ userManagement }) => userManagement.user,
      subscriptions: ({ userManagement }) => userManagement.subscriptions,
    }),
  },
  methods: {
    ...mapActions({
      getUserSubscriptions: 'userManagement/getUserSubscriptions',
    }),
  },
  mounted() {
    if (this.user) {
      this.getUserSubscriptions({
        id: this.user.id,
        page: this.currentPage,
        limit: this.itemsPerPage,
      })
        .then(response => {
          this.currentPage = parseInt(response.headers['x-pagination-page']);
          this.pageTotal = parseInt(response.headers['x-pagination-count']);
          this.totalItem = parseInt(response.headers['x-pagination-total']);
          this.totalPage = parseInt(response.headers['x-pagination-page-count']);
        })
        .catch(err => {
          console.error(err);
        });
    }
  },
  watch: {
    async currentPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        await this.getUserSubscriptions({
          id: this.user.id,
          page: this.currentPage,
          limit: this.itemsPerPage,
        });
      }
    },
  },
};
</script>
<style lang="scss"></style>
